import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `panel-preferences/$panelPreferenceId/edit`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/settings/organization/pcb/$panelPreferenceId')({
    // Only redirects: `edit` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit',
            params: { panelPreferenceId: params.panelPreferenceId },
            search: true,
            replace: true,
        });
    },
});
